if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.initializeColorGallery();
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      initializeColorGallery() {
        const source = this.querySelector('[data-oh-color-catalog]');
        if (!source) return;
        try { this.colorCatalog = JSON.parse(source.textContent); } catch { return; }
        this.applyColor(this.colorCatalog.selected);
      }

      applyColor(color, preferredId) {
        const ids = this.colorCatalog?.groups[color];
        if (!ids?.length) return null;
        const allowed = new Set(ids.map(String));
        this.dataset.ohColor = color;
        const section = this.colorCatalog.section;
        const mainItems = [...this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]')];
        for (const item of mainItems) {
          item.classList.remove('product__media-item--variant');
          item.hidden = !allowed.has(item.dataset.mediaId.slice(section.length + 1));
          if (item.hidden) item.classList.remove('is-active');
        }
        const thumbnails = this.elements.thumbnails;
        if (thumbnails) {
          for (const item of thumbnails.querySelectorAll('[data-target]')) {
            item.classList.remove('thumbnail-list_item--variant');
            item.hidden = !allowed.has(item.dataset.target.slice(section.length + 1));
          }
          thumbnails.hidden = ids.length < 2;
          thumbnails.classList.toggle('thumbnail-slider--no-slide', ids.length <= 3);
          thumbnails.querySelectorAll('.slider-button').forEach(button => {
            button.classList.toggle('small-hide', ids.length <= 3);
            button.classList.toggle('medium-hide', ids.length <= 4);
            button.classList.toggle('large-up-hide', ids.length <= 4);
          });
        }
        const modal = document.getElementById(`ProductModal-${section}`);
        modal?.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach(item => {
          item.classList.remove('product__media-item--variant');
          item.toggleAttribute('data-oh-color-hidden', !allowed.has(item.dataset.mediaId));
        });
        const activeId = allowed.has(String(preferredId)) ? String(preferredId) : ids[0];
        const currentActive = mainItems.find(item => item.classList.contains('is-active') && !item.hidden);
        if (!currentActive || preferredId) {
          mainItems.forEach(item => item.classList.toggle('is-active', item.dataset.mediaId === `${section}-${activeId}`));
        }
        for (const slider of [this.elements.viewer, thumbnails]) {
          if (!slider?.slider) continue;
          slider.slider.scrollLeft = 0;
          slider.resetPages?.();
          if ((slider.sliderItemsToShow?.length || 0) < 2) {
            slider.sliderItemOffset = slider.sliderItemsToShow?.[0]?.clientWidth || 1;
            slider.totalPages = 1;
            slider.currentPage = 1;
            if (slider.currentPageElement) slider.currentPageElement.textContent = '1';
            if (slider.pageTotalElement) slider.pageTotalElement.textContent = '1';
            slider.prevButton?.setAttribute('disabled', 'disabled');
            slider.nextButton?.setAttribute('disabled', 'disabled');
          }
        }
        return activeId;
      }

      setColorVariant(variant) {
        if (!this.colorCatalog) return null;
        return this.applyColor(variant.options[this.colorCatalog.position], variant.featured_media?.id);
      }


      onSlideChanged(event) {
        if (!event.detail.currentElement) return;
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia || activeMedia.hidden) return;
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

